let installed = false;
let redirecting = false;

function getRequestUrl(input) {
  if (typeof input === "string") return input;
  if (input instanceof URL) return input.href;
  return input?.url;
}

function isApiRequest(input) {
  try {
    const rawUrl = getRequestUrl(input);
    if (!rawUrl) return false;
    const url = new URL(rawUrl, window.location.origin);
    return url.origin === window.location.origin && url.pathname.startsWith("/api/");
  } catch {
    return false;
  }
}

function isLoginRequest(input) {
  try {
    const rawUrl = getRequestUrl(input);
    const url = new URL(rawUrl, window.location.origin);
    return url.pathname === "/api/auth/login";
  } catch {
    return false;
  }
}

export function installAuthFetchInterceptor() {
  if (installed || typeof window === "undefined") return;

  installed = true;
  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (...args) => {
    const response = await nativeFetch(...args);
    const [input] = args;

    if (
      response.status === 401 &&
      isApiRequest(input) &&
      !isLoginRequest(input) &&
      localStorage.getItem("token") &&
      !redirecting
    ) {
      redirecting = true;
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.setItem("session_expired", "1");

      if (window.location.pathname !== "/login") {
        window.location.replace("/login");
      }
    }

    return response;
  };
}
